var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6175 8.14747C12.7802 7.95958 12.7802 7.6807 12.6175 7.49282L6.2789 0.173675C5.97584 -0.176276 5.40094 0.0380604 5.40094 0.501003V4.15987H1.40094C1.1248 4.15987 0.90094 4.38373 0.90094 4.65987V10.6599C0.90094 10.936 1.1248 11.1599 1.40094 11.1599H5.40094V15.1393C5.40094 15.6022 5.97584 15.8166 6.2789 15.4666L12.6175 8.14747Z",
    fill: "#4893CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/Flat.5c413e32b7c4677a29e4bbc66c76a9ef.svg";
export { ForwardRef as ReactComponent };